import React, { createContext, useContext, useState } from "react"

const tokenDataContext = createContext({
  tokenData: {},
  setTokenData: () => {},
  tokenMotive: "green_blue",
  enableWizardButtons: null,
})
export const tokenMotivesList =[
  "green_blue",
  "yellow_pink"
]
export const TokenDataProvider = ({ children }) => {
  const [tokenData, setTokenData] = useState({})
  const tokenMotive =
    tokenData &&
    tokenData?.TokenInfo &&
    tokenMotivesList.includes(tokenData.TokenInfo.motive)
      ? tokenData.TokenInfo.motive
      : "green_blue"
  let enableWizardButtons = null
  if (
    tokenData &&
    tokenData?.TokenInfo &&
    (tokenData.TokenInfo.enableWizardButtons === true ||
      tokenData.TokenInfo.enableWizardButtons === false)
  ) {
    enableWizardButtons = tokenData.TokenInfo.enableWizardButtons
  }
  return (
    <tokenDataContext.Provider
      value={{ tokenData, setTokenData, tokenMotive, enableWizardButtons }}>
      {children}
    </tokenDataContext.Provider>
  )
}
export const useTokenDataContext = () => useContext(tokenDataContext)
